import { render, staticRenderFns } from "./RegularTabProcessing.vue?vue&type=template&id=41886d4f&scoped=true"
import script from "./RegularTabProcessing.vue?vue&type=script&lang=js"
export * from "./RegularTabProcessing.vue?vue&type=script&lang=js"
import style0 from "./RegularTabProcessing.vue?vue&type=style&index=0&id=41886d4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41886d4f",
  null
  
)

export default component.exports